import { Navigate, Outlet } from "react-router";
import { useAuth } from "~/lib/hooks/use-auth";

export default function PublicLayout() {
	const { user, loading } = useAuth();

	if (loading) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<div className="loading loading-spinner loading-lg" />
			</div>
		);
	}

	if (user) {
		return <Navigate to="/dashboard" replace />;
	}

	return <Outlet />;
}
